import { Inter, Roboto } from 'next/font/google';

// const fontHeading = Poppins({
//   weight: ['400', '500', '600', '700', '800'],
//   subsets: ['latin'],
//   display: 'swap',
// });
// const fontBody = Montserrat({
//   weight: ['500', '600', '700', '800', '900'],
//   subsets: ['latin'],
//   display: 'swap',
// });

const fontHeading = Inter({
  weight: ['400', '500', '600', '700', '800'],
  subsets: ['latin'],
  display: 'swap',
});
const fontBody = Roboto({
  weight: ['400', '500', '700', '900'],
  subsets: ['latin'],
  display: 'swap',
});

export default {
  fontBody,
  fontHeading,
};
